// Imports for external libraries go here.
import React, { FC, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Config, EditableComponent, MappedComponentProperties } from '@adobe/aem-react-editable-components';
// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { RTEProps } from './RTE.types';
import { TermsOfUse } from './components/TermsOfUse';
import { Upgrade } from './components/Upgrade';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

// Use named rather than default exports.
export const RTE: FC<RTEProps> = ({ ppv5RTE }) => {
  const router = useRouter();
  const slug = router.query['index'];

  useEffect(() => {
    document.querySelector('.global-nav')?.classList.add('page-wrap');
  });

  return slug?.includes('upgrade') ? <Upgrade ppv5RTE={ppv5RTE} /> : <TermsOfUse ppv5RTE={ppv5RTE} />;
};

export const RTEConfig = {
  emptyLabel: 'RTEComponnet',
  isEmpty: (_props: MappedComponentProperties) => false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/ppv5-rte`,
} as Config<MappedComponentProperties>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const RTEEditable = (props: RTEProps) => {
  return (
    <div data-testid="rte-editable" className="standard">
      <EditableComponent config={RTEConfig} {...props}>
        <RTE {...props} />
      </EditableComponent>
    </div>
  );
};
